// Imported & adapted from https://github.com/dominiklessel/node-barcoder/blob/master/lib/barcoder.js
//
const validationRegex = /^\d{8,14}$/;

function toInt(numString: string): number {
  return parseInt(numString, 10);
}

function isOdd(num: number): boolean {
  return num % 2 === 1;
}

/**
 * Calculates a checksum (Modulo 10)
 * GTIN implementation factor 3.
 */
function calculateChecksum(gtin: string): number {
  const parsedGtin = parseInt(gtin, 10).toString();
  const chunks = parsedGtin.split('').map(toInt).reverse();
  let checksum = 0;

  // Remove first chuck (checksum)
  chunks.shift();

  // sum numbers and multiply accordingly
  chunks.forEach(function (number, index) {
    checksum += isOdd(index) ? number : number * 3;
  });

  // calc checksum
  checksum %= 10;
  checksum = checksum === 0 ? 0 : 10 - checksum;

  return checksum;
}

/**
 * Validates a barcode.
 */
export function validateBarcode(barcode: string | null | undefined): boolean {
  if (!barcode) {
    return false;
  }
  if (validationRegex.exec(parseInt(barcode).toString()) === null) {
    return false;
  }

  const checksum = parseInt(barcode.substring(barcode.length - 1), 10);
  const calcChecksum = calculateChecksum(barcode);

  return checksum === calcChecksum;
}

export type BarcodeType = 'ean-13' | 'upc-a' | 'other';

/**
 * Identify barcode.
 */
export function identifyBarcode(barcode: string | null | undefined): BarcodeType | null {
  if (!barcode || !validateBarcode(barcode)) {
    return null;
  }

  switch (barcode.length) {
    case 12:
      return 'upc-a';
    case 13:
      return 'ean-13';
    default:
      return 'other';
  }
}
